import { addMethod as yupAddMethod, string as yupString } from 'yup';

/**
 * Override for "yup" email validation
 *  - https://github.com/jquense/yup?tab=readme-ov-file#stringemailmessage-string--function-schema
 *  - WATCH OUT: Validating email addresses is nearly impossible with just code.
 *    - Different clients and servers accept different things and many diverge from the various specs defining "valid" emails.
 *    - The ONLY real way to validate an email address is to send a verification email to it and check that the user got it.
 *    - With that in mind, yup picks a relatively simple regex that does not cover all cases, but aligns with browser input validation behavior since HTML forms are a common use case for yup.
 * - If you have more specific needs please override the email method with your own logic or regex:
 */
yupAddMethod(yupString, 'email', function validateEmail(message) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return this.matches(emailRegex, {
    message,
    name: 'email',
    excludeEmptyString: true,
  });
});
